import { Experiment } from '@ms/yammer-data/dist/state/types';
import { useIsAskMeAnythingEnabled } from '@ms/yammer-hooks/dist/askMeAnything';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';
import { useShouldShowNewEventsLayout } from '@ms/yammer-hooks/dist/routes';
import PageLayout from '@ms/yammer-web-core-ui/dist/components/PageLayout';
import { eventPageMatchPath } from '@ms/yammer-web-support/dist/urls';
import React, { FC } from 'react';
import { Route, Switch } from 'react-router-dom';

import Page from '../Page';

import { ContentRoutes } from './ContentRoutes';
import {
  AskMeAnything,
  AskMeAnythingLeadersEvents,
  AskMeAnythingUserEvents,
  GroupInsights,
  LiveEvent,
  Logout,
  UserInsights,
} from './loadableComponents';

const Routes: FC = () => {
  const shouldShowNewEventsLayout = useShouldShowNewEventsLayout();
  const isAskMeAnythingEnabled = useIsAskMeAnythingEnabled();
  const userInsightsExperimentEnabled = useExperimentTreatmentWithoutReporting(Experiment.UserInsights) === true;
  const askMeAnythingPage = isAskMeAnythingEnabled ? (
    <Route path="/ama/:teamsMeetingId">
      <Page>
        <AskMeAnything />
      </Page>
    </Route>
  ) : null;
  const askMeAnythingUserEventsPage = isAskMeAnythingEnabled ? (
    <Route path="/users/:userId/events/askmeanything">
      <Page>
        <AskMeAnythingUserEvents />
      </Page>
    </Route>
  ) : null;
  const askMeAnythingLeadersEventsPage = isAskMeAnythingEnabled ? (
    <Route path="/leadership-corner/events/askmeanything">
      <Page>
        <AskMeAnythingLeadersEvents />
      </Page>
    </Route>
  ) : null;
  const userInsightsPage = userInsightsExperimentEnabled ? (
    <Route path="/users/:userId/insights">
      <Page>
        <UserInsights />
      </Page>
    </Route>
  ) : null;

  return (
    <Switch>
      <Route path={eventPageMatchPath}>
        <Page
          collapseLeftSidebar={shouldShowNewEventsLayout}
          noScroll={shouldShowNewEventsLayout}
          noSpacing={shouldShowNewEventsLayout}
        >
          <LiveEvent />
        </Page>
      </Route>
      {askMeAnythingPage}
      {askMeAnythingUserEventsPage}
      {askMeAnythingLeadersEventsPage}
      <Route path="/groups/:groupId/activity">
        <Page>
          <GroupInsights />
        </Page>
      </Route>
      {userInsightsPage}
      <Route path="/logout">
        <PageLayout>
          <Logout />
        </PageLayout>
      </Route>
      <Route default={true}>
        <Page>
          <ContentRoutes />
        </Page>
      </Route>
    </Switch>
  );
};

export default Routes;
